<template>
  <!-- Page content -->
  <div class="page-content" v-if="username">
    <!-- Main content -->
    <div class="content-wrapper">
      <!-- Page header -->
      <div class="page-header mb-2">
        <div class="page-header-content header-elements-md-inline">
          <div class="page-title d-flex">
            <h4 class="font-weight-semibold">Tasks Management</h4>
          </div>
          <div class="d-flex" style="gap: 16px">
            <div class="d-flex" style="gap: 8px">
              <div class="mr-1 d-flex align-items-center">Date</div>
              <date-picker
                class="mr-1"
                placeholder="Date"
                v-model="selectedDate"
                value-type="format"
                format="D MMM YYYY"
                @change="loadData"
                style="width: 120px"
              ></date-picker>
            </div>

            <div class="d-flex" style="gap: 8px">
              <div class="mr-1 d-flex align-items-center">Status</div>
              <select v-model="status" class="form-control mr-1">
                <option value>All</option>
                <option value="New">New</option>
                <option value="To do">To do</option>
                <option value="In progress">In progress</option>
                <option value="To review">To review</option>
                <option value="In review">In review</option>
                <option value="Reject">Reject</option>
                <option value="Done">Done</option>
              </select>
            </div>

            <div class="d-flex" style="gap: 8px">
              <div class="mr-1 d-flex align-items-center text-nowrap">File Type</div>
              <select v-model="sentiment" class="form-control mr-1">
                <option value>All</option>
                <option value="positive">Positive</option>
                <option value="neutral">Neutral</option>
                <option value="negative">Negative</option>
                <option value="incident">Incident</option>
                <option value="ระบบล่ม">ระบบล่ม</option>
                <option value="เฝ้าระวัง">เฝ้าระวัง</option>
              </select>
            </div>

            <div class="d-flex" style="gap: 8px">
              <div class="mr-1 d-flex align-items-center">Assignee</div>
              <div style="min-width: 180px">
                <v-select
                  class="mr-1"
                  v-if="isAdmin"
                  :options="assignees"
                  :reduce="(assignee) => assignee.username"
                  label="username"
                  v-model="assignee"
                  placeholder="All"
                />
              </div>
            </div>

            <div class="d-flex" style="gap: 8px">
              <div class="mr-1 d-flex align-items-center">Reviewer</div>
              <div style="min-width: 180px">
                <v-select
                  class="mr-1"
                  v-if="isAdmin"
                  :options="reviewers"
                  :reduce="(assignee) => assignee.username"
                  label="username"
                  v-model="reviewer"
                  placeholder="All"
                />
              </div>
            </div>

            <!-- <router-link
              v-if="isAdmin"
              to="/export"
              type="button"
              class="btn btn-primary"
              ><i class="fas fa-download mr-2"></i> Data Export</router-link
            > -->
          </div>
        </div>
      </div>
      <!-- /page header -->

      <!-- Content area -->

      <div class="content pt-0">
        <div class="row">
          <div class="col-xl-12">
            <div class="card" v-if="chunks.length === 0 || fileCount === 0">
              <div class="card-body">
                <loading v-if="isLoading"></loading>
                <div v-else>No Data</div>
              </div>
            </div>
            <template v-else>
              <div
                class="card"
                v-for="weeklyData in chunks"
                :key="weeklyData.title"
              >
                <div v-if="weeklyData.datas.length > 0">
                  <div class="card-header title-text fw-600">
                    <div class="d-flex justify-content-between">
                      <div>{{ weeklyData.title }}</div>
                      <div
                        class="d-flex"
                        style="gap: 8px"
                        v-if="isAdmin && weeklyData.datas.length > 0"
                      >
                        <button
                          :disabled="!weeklyData.allowSyncUpdate"
                          class="btn btn-sm btn-outline-primary"
                          @click="confirmSyncUpdateWeek(weeklyData)"
                        >
                          Sync update
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-primary"
                          @click="confirmExportWeek(weeklyData)"
                        >
                          Export data
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <table
                      class="table border-none border-radius-4 text-grey-800"
                    >
                      <thead class="bg-grey-100">
                        <tr>
                          <th class="text-grey-800" style="min-width: 290px">
                            File Info
                          </th>
                          <th class="text-grey-800" style="min-width: 190px">
                            Assignee name
                          </th>
                          <th class="text-grey-800" style="min-width: 200px">
                            Due date
                          </th>
                          <th class="text-grey-800" style="min-width: 100px">
                            Status
                          </th>
                          <th class="text-grey-800" style="min-width: 130px">
                            Progress
                          </th>
                          <th
                            class="text-grey-800"
                            style="min-width: 160px"
                            v-if="isAdmin"
                          >
                            Reviewer name
                          </th>
                          <th
                            class="text-grey-800"
                            style="min-width: 48px"
                            v-if="isAdmin"
                          ></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-if="
                            weeklyData.datas && weeklyData.datas.length === 0
                          "
                        >
                          <td colspan="7">No Data</td>
                        </tr>
                        <tr
                          v-else
                          v-for="item in weeklyData.datas"
                          :key="item._id"
                          :class="{ tagging: isTagging(item._id) }"
                        >
                          <td>
                            <div class="fw-500 fs-14">
                              <router-link
                                target="_blank"
                                v-if="
                                  (!isAdmin && item.status !== 'To review') ||
                                  isAdmin
                                "
                                :to="'/editor/' + item._id"
                                >{{ item.filename }}</router-link
                              >
                              <span class="link-disabled" v-else>{{
                                item.filename
                              }}</span>
                            </div>
                            <div class="text-grey-desc fs-11">
                              File Update : {{ item.updatedAtFormat }}
                            </div>
                            <div
                              class="text-grey-size d-flex align-items-center fs-13"
                              style="gap: 8px"
                            >
                              <div>
                                File size :
                                <span class="fw-500">{{
                                  Number(item.count).toLocaleString()
                                }}</span>
                              </div>
                              <span class="text-grey-400">|</span>
                              <SourcesCount
                                :sources="item.sourceCount"
                                :show-zero="false"
                              ></SourcesCount>
                            </div>
                          </td>

                          <td>
                            <div v-if="isAdmin && !item.isReviewOrDone">
                              <div>
                                <v-select
                                  class="mr-1"
                                  @input="assignToChunk(item)"
                                  v-if="isAdmin"
                                  :options="assignees"
                                  :reduce="(assignee) => assignee.username"
                                  label="username"
                                  v-model="item.assignToValue"
                                  placeholder="Assignee"
                                />
                              </div>
                            </div>
                            <span v-else>{{ item.assignTo || '-' }}</span>
                          </td>

                          <td>
                            <div>
                              <div v-if="isAdmin && !item.isReviewOrDone">
                                <date-picker
                                  placeholder="Date"
                                  v-model="item.dueDateFormat"
                                  value-type="format"
                                  format="D MMM YYYY"
                                  @change="setDueDate($event, item._id)"
                                  style="width: 120px"
                                ></date-picker>
                              </div>
                              <span v-else>
                                <span v-if="item.dueDateFormat">{{
                                  item.dueDateFormat
                                }}</span>
                                <span v-else>-</span>

                                <span
                                  v-if="item.isLate"
                                  class="ml-2 badge badge-pill badge-late fs-11"
                                  >late</span
                                >
                              </span>
                            </div>
                          </td>

                          <td>
                            <span
                              class="badge badge-pill badge-primary fs-11"
                              :class="classButton(item.status)"
                            >
                              {{ item.status }}</span
                            >
                          </td>

                          <td>
                            <div>
                              <div class="text-grey-600 fw-400 mb-1">
                                {{ item.progress.toLocaleString() }}/{{
                                  item.total.toLocaleString()
                                }}
                              </div>
                              <div class="progress mb-0">
                                <div
                                  class="progress-bar bg-success"
                                  :style="{ width: item.percent + '%' }"
                                ></div>
                              </div>
                              <div
                                class="text-grey-600 fw-400 mb-1 fs-11"
                                v-if="item.submitDateFormat"
                              >
                                <div>Submit#{{ item.submitDateFormat.index }} {{ item.submitDateFormat.text }}</div>
                              </div>
                            </div>
                          </td>

                          <td v-if="isAdmin">
                            <div>
                              <v-select
                                class="mr-1"
                                @input="assignReviewer(item)"
                                v-if="isAdmin"
                                :options="reviewers"
                                :reduce="(assignee) => assignee.username"
                                label="username"
                                v-model="item.reviewerValue"
                                placeholder="Reviewer"
                              />
                            </div>
                          </td>

                          <td v-if="isAdmin">
                            <b-dropdown
                              size="sm"
                              variant="link"
                              toggle-class="toggle-bg btn-dropdown-custom"
                              no-caret
                            >
                              <template #button-content>
                                <i class="fas fa-ellipsis-h ellipse"></i>
                              </template>
                              <b-dropdown-item
                                @click="confirmExportDataItem(item)"
                                ><i class="fas fa-arrow-up-from-bracket"></i>
                                <span>Export data</span></b-dropdown-item
                              >
                              <b-dropdown-item
                                :disabled="!item.allowSyncUpdate"
                                v-b-modal.split-file-modal
                                @click="openSplitFile(item)"
                                ><i class="fas fa-list-check"></i>
                                <span>Split file</span></b-dropdown-item
                              >
                              <b-dropdown-item
                                :disabled="!item.allowSyncUpdate"
                                @click="confirmSyncUpdateItem(item)"
                                ><i class="fas fa-rotate"></i>
                                <span>Sync update</span></b-dropdown-item
                              >
                            </b-dropdown>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- /content area -->

      <!-- Footer -->
      <!-- <div class="navbar navbar-expand-lg navbar-light">
        <div class="navbar-collapse collapse" id="navbar-footer">
          <span class="navbar-text">
            &copy; 2015 - 2018. InsightEra Co., Ltd
          </span>
        </div>
      </div> -->
      <!-- /footer -->
    </div>
    <!-- /main content -->
    <ModalSplitFile
      v-if="splitFile"
      :data="splitFile"
      @success="resetSplitFile"
    ></ModalSplitFile>
    <ConfirmSyncUpdateModal
      v-model="openSyncModal"
      @close="openSyncModal = false"
      @sync="syncUpdateData"
      :data="selectedWeekOrFile"
    ></ConfirmSyncUpdateModal>
    <ExportDataModal
      v-model="openExportDataModal"
      @close="openExportDataModal = false"
      @export="exportData"
      :filename="selectedWeekOrFile.title"
    ></ExportDataModal>
  </div>
  <!-- /page content -->
</template>
<script>
import { VBModal, BDropdown, BDropdownItem } from 'bootstrap-vue'
import Loading from '../components/Loading'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import serviceRoutes from '../service-routes'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import ModalSplitFile from './record_chunk/ModalSplitFile.vue'
import SourcesCount from '../components/SourcesCount.vue'
import ConfirmSyncUpdateModal from '../components/ConfirmSyncUpdateModal.vue'
import ExportDataModal from '../components/ExportDataModal.vue'
export default {
  components: {
    SourcesCount,
    Loading,
    ModalSplitFile,
    BDropdown,
    BDropdownItem,
    ConfirmSyncUpdateModal,
    ExportDataModal
  },
  directives: {
    'b-modal': VBModal
  },
  data() {
    return {
      sentiment: '',
      splitFile: null,
      selectedDate: null,
      status: '',
      reviewer: '',
      reviewers: [],
      assignee: '',
      range: null,
      user: '',
      pass: '',
      isLoading: true,
      assignees: [],
      openSyncModal: false,
      openExportDataModal: false,
      selectedWeekOrFile: {
        item: null,
        week: null,
        title: ''
      }
    }
  },
  beforeMount() {
    // if (this.chunkFilter && Object.keys(this.chunkFilter).length) {
    //   this.status = this.chunkFilter.status || ''
    //   this.assignee = this.chunkFilter.assignee || ''
    //   this.range = this.chunkFilter.range
    // }
    this.initFilter()
  },
  mounted() {
    if (this.isAuth && this.username) {
      this.loadData()
      if (this.isAdmin) {
        this.getAssignees()
      }
    }
  },
  beforeDestroy() {
    if (this.$swal && typeof this.$swal.close === 'function') {
      this.$swal.close()
    }
  },
  watch: {
    status: function() {
      this.setTaskFilter({ status: this.status })
    },
    reviewer: function() {
      this.setTaskFilter({ reviewer: this.reviewer })
    },
    selectedDate: {
      handler() {
        this.setTaskFilter({ selectedDate: this.selectedDate })
      },
      deep: true
    },
    assignee: function() {
      this.setTaskFilter({ assignee: this.assignee })
    }
  },
  computed: {
    ...mapGetters({
      isAuth: 'isAuth',
      role: 'role',
      chunkData: 'chunkData',
      username: 'username',
      password: 'password',
      errorMsg: 'errorMsg',
      accountId: 'accountId',
      userTagging: 'userTagging',
      isAdmin: 'isAdmin',
      taskFilter: 'taskFilter'
    }),
    fileCount() {
      return this.chunks.reduce((prev, curr) => {
        const count = prev += curr.datas.length
        return count
      }, 0)
    },
    chunks() {
      return _.cloneDeep(this.chunkData).map((chunk) => {
        chunk.title = `${moment(chunk.start).format('DD/MM/YYYY')} - ${moment(
          chunk.end
        ).format('DD/MM/YYYY')}`

        chunk.datas = _.cloneDeep([...chunk.datas])
          .map((chunk) => {
            chunk.assignTo = chunk.assignTo || ''
            chunk.assignToValue = chunk.assignTo
            chunk.reviewer = chunk.reviewer || ''
            chunk.reviewerValue = chunk.reviewer
            chunk.dueDateFormat = chunk.dueDate
              ? moment(chunk.dueDate).format('D MMM YYYY')
              : null

            const name = chunk.name ? `${_.capitalize(chunk.name)} ` : (chunk.sentiment ? ` ${_.capitalize(chunk.sentiment)} ` : '')

            chunk.filename =
              moment(chunk.endDate).format('DD MMM') +
              ' ' + name +
              (chunk.criteria && chunk.criteria.category
                ? `- ${chunk.criteria.category[0]}`
                : chunk.filename)

            chunk.isReviewOrDone = ['To review', 'Done'].includes(chunk.status)
            chunk.percent = Math.floor((chunk.progress / chunk.total) * 100)
            chunk.updatedAtFormat = moment(chunk.updatedAt).format('D MMM YYYY')

            chunk.allowSyncUpdate = this.canSyncUpdate(chunk)
            return chunk
          })
          .filter((d) => {
            return (
              (!this.status || this.status === d.status) &&
              (!this.assignee || this.assignee === d.assignTo) &&
              (!this.reviewer || this.reviewer === d.reviewer) &&
              (!this.sentiment || (this.sentiment === d.sentiment || this.sentiment === d.name))
            )
          })

        chunk.allowSyncUpdate =
          chunk.datas.filter((v) => v.allowSyncUpdate).length > 0
        return chunk
      })
    },
    onlyDatas() {
      const datas = this.chunks.filter((v) => !v.header && !v.nodata)
      const orderByStatus = [
        ...datas.filter((d) => d.status === 'Reject'),
        ...datas.filter((d) => d.status === 'In progress'),
        ...datas.filter((d) => d.status === 'To do'),
        ...datas.filter((d) => d.status === 'New'),
        ...datas.filter((d) => d.status === 'To review'),
        ...datas.filter((d) => d.status === 'Done')
      ]
      return orderByStatus
    }
  },
  methods: {
    ...mapActions({
      getUsers: 'getUsers',
      getChunkData: 'getChunkData',
      auth: 'auth',
      updateChunkData: 'updateChunkData',
      setUsername: 'setUsername',
      setPassword: 'setPassword',
      exportByChunkId: 'exportByChunkId',
      exportByDate: 'exportByDate',
      setErrorMsg: 'setErrorMsg',
      setIsAuth: 'setIsAuth',
      loadExportHistory: 'loadExportHistory',
      showExportHistory: 'showExportHistory',
      setTaskFilter: 'setTaskFilter'
    }),
    async convertCategory(chunkId) {
      return serviceRoutes.convertCategory(chunkId).catch(() => {})
    },
    moment,
    loadData: _.debounce(async function () {
      this.isLoading = true
      let filter = {
        configId: this.accountId,
        username: this.username
      }

      if (this.selectedDate) {
        this.range = {
          start: moment(this.selectedDate, 'D MMM YYYY')
            .startOf('isoWeek')
            .startOf('day')
            .valueOf(),
          end: moment(this.selectedDate, 'D MMM YYYY')
            .endOf('isoWeek')
            .endOf('day')
            .valueOf()
        }
      } else {
        this.range = null
      }

      if (this.range) {
        filter.range = this.range
      }
      this.setTaskFilter(filter)

      await this.getChunkData(filter)
      this.isLoading = false
    }, 500),
    async updateStatus(item, idx) {
      await this.updateChunkData({ chunkId: item._id, status: item.status })
    },
    async getAssignees() {
      const users = await this.getUsers()
      this.assignees = users
      this.reviewers = users.filter((u) => u.role === 'admin')
    },
    async exportRawData(item, filename, exportColumn) {
      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: 'Exporting...',
        showConfirmButton: false,
        showCloseButton: true
      })
      if (item.week) {
        const response = await this.exportByDate({
          configId: item.week.configId,
          start: item.week.start,
          end: item.week.end,
          filename,
          exportColumn
        })
        if (!response) {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Something went wrong',
            showConfirmButton: false,
            showCloseButton: true
          })
        }
      } else {
        const response = await this.exportByChunkId({
          chunkId: item.item._id,
          configId: item.item.configId,
          filename,
          exportColumn
        })
        if (!response) {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Something went wrong',
            showConfirmButton: false,
            showCloseButton: true
          })
        }
      }

      this.openExportDataModal = false
      this.loadExportHistory()
      this.showExportHistory(true)
    },
    classButton(status) {
      if (status === 'In progress') {
        return 'badge badge-in-progress'
      } else if (status === 'Done') {
        return 'badge badge-done'
      } else if (status === 'In review') {
        return 'badge badge-in-review'
      } else if (status === 'To review') {
        return 'badge badge-to-review'
      } else if (status === 'Reject') {
        return 'badge badge-reject'
      } else if (status === 'To do') {
        return 'badge badge-todo'
      } else {
        return 'badge badge-new'
      }
    },
    dueButton(status) {
      if (status === 'late') {
        return 'badge badge-pill badge-danger'
      }
      return ''
    },
    async assignToChunk(item) {
      await this.updateChunkData({
        chunkId: item._id,
        assignTo: item.assignToValue
      })
      this.loadData()
    },
    async assignReviewer(item) {
      await this.updateChunkData({
        chunkId: item._id,
        reviewer: item.reviewerValue
      })
      this.loadData()
    },
    async setDueDate(unixTimestamp, chunkId) {
      await this.updateChunkData({
        chunkId: chunkId,
        dueDate: moment(unixTimestamp, 'D MMM YYYY').valueOf()
      })
      await this.loadData()
    },
    loadByDateBySeletedDate(date) {
      if (date) {
        this.range = {
          start: moment(date, 'D MMM YYYY')
            .startOf('isoWeek')
            .startOf('day')
            .valueOf(),
          end: moment(date, 'D MMM YYYY')
            .endOf('isoWeek')
            .endOf('day')
            .valueOf()
        }
      } else {
        this.range = null
        // this.range = {
        //   start: moment().startOf('month').startOf('isoWeek').valueOf(),
        //   end: moment().endOf('day').endOf('isoWeek').valueOf()
        // }
        if (this.role === 'user') {
          this.range = null
        }
      }
      this.loadData()
    },
    isTagging(chunkId) {
      return this.userTagging.filter((v) => v.chunkId === chunkId).length > 0
    },
    async matchingSensitiveArea(chunkId) {
      return serviceRoutes
        .matchingSensitiveAreaByChunkId(chunkId)
        .catch(() => {})
    },
    exportExcel(start, end) {
      const data = this.chunks
        .filter(
          (v) =>
            v.createdAt &&
            moment(v.dataDate).isSameOrAfter(moment(start)) &&
            moment(v.dataDate).isSameOrBefore(moment(end))
        )
        .map((v) => {
          return { ...v, doing: `${v.progress}/${v.total}` }
        })
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('My Sheet')

      sheet.columns = [
        { header: 'Filename', key: 'filename', width: 15 },
        { header: 'Size', key: 'count', width: 10 },
        { header: 'Assignee', key: 'assignTo', width: 10 },
        { header: 'Due Date', key: 'dueDateFormat', width: 15 },
        { header: 'Update Date', key: 'updatedAtFormat', width: 15 },
        { header: 'Status', key: 'status', width: 10 },
        { header: 'Submit Date', key: 'submitDateFormat', width: 15 },
        { header: 'Due Status', key: 'submittedStatus', width: 10 },
        { header: 'Payment Status', key: 'paymentStatus', width: 15 },
        { header: 'Doing', key: 'doing', width: 10 }
      ]

      for (const index in sheet.columns) {
        sheet.getRow(1).getCell(+index + 1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF860B' }
        }
      }

      sheet.addRows(data)
      workbook.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        saveAs(blob, 'files.xlsx')
      })
    },
    openSplitFile(data) {
      this.splitFile = data
    },
    resetSplitFile() {
      this.splitFile = null
      this.loadData()
    },
    async syncUpdate(id) {
      await Promise.all([
        this.convertCategory(id),
        this.matchingSensitiveArea(id)
      ])
    },
    confirmSyncUpdateWeek(week) {
      this.selectedWeekOrFile = {
        title: week.title,
        week,
        item: null
      }
      this.openSyncModal = true
    },
    confirmSyncUpdateItem(item) {
      this.selectedWeekOrFile = {
        title: item.filename,
        item,
        week: null
      }
      this.openSyncModal = true
    },
    canSyncUpdate(item) {
      return ['New', 'To do'].includes(item.status)
    },
    async syncUpdateData() {
      let promises = []
      if (this.selectedWeekOrFile.week) {
        const items = this.selectedWeekOrFile.week.datas
        for (const item of items) {
          if (this.canSyncUpdate(item)) {
            promises.push(this.syncUpdate(item._id))
          }
        }
      } else if (this.selectedWeekOrFile.item) {
        if (this.canSyncUpdate(this.selectedWeekOrFile.item)) {
          promises.push(this.syncUpdate(this.selectedWeekOrFile.item._id))
        }
      }
      await Promise.all(promises)
      this.openSyncModal = false

      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: 'Successfully sync update data',
        showConfirmButton: false,
        showCloseButton: true
      })

      this.loadData()
    },

    confirmExportWeek(week) {
      this.selectedWeekOrFile = {
        title: week.title,
        week,
        item: null
      }
      this.openExportDataModal = true
    },
    confirmExportDataItem(item) {
      this.selectedWeekOrFile = {
        title: item.filename,
        item,
        week: null
      }
      this.openExportDataModal = true
    },
    async exportData({ currentFileName, exportColumn }) {
      await this.exportRawData(this.selectedWeekOrFile, currentFileName, exportColumn)
      this.openExportDataModal = false
    },
    initFilter() {
      if (this.taskFilter) {
        if (this.taskFilter.selectedDate) {
          this.selectedDate = this.taskFilter.selectedDate
        }
        if (this.taskFilter.status) {
          this.status = this.taskFilter.status
        }
        if (this.taskFilter.assignee) {
          this.assignee = this.taskFilter.assignee
        }
        if (this.taskFilter.reviewer) {
          this.reviewer = this.taskFilter.reviewer
        }
      }
    }
  }
}
</script>
<style scoped>
.progress {
  height: 0.5rem;
  border-radius: 7px;
}
.tagging {
  border-left: 4px solid;
  border-color: red;
}

input.vs__search::placeholder {
  font-size: 13px;
}

.ellipse {
  color: #878a99;
}

>>> button.btn-dropdown-custom {
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
}

>>> a.dropdown-item {
  color: #5a5f7d !important;
}

>>> a.dropdown-item:hover {
  color: #2196f3 !important;
  background-color: #e9f4fe !important;
}

>>> .toggle-bg:hover {
  background-color: #f5f6fa;
}

td {
  padding: 24px 10px;
}

th {
  padding: 12px 10px;
}

>>> .vs__selected-options .vs__search:nth-child(2){
  padding:0px;
}
</style>
